import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, Facebook, Instagram, Twitter } from 'lucide-react';
import { serviceAreas } from '../mockData';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_roof-clean-heroes/artifacts/dpmknklk_Screenshot%202025-10-24%20202236.png"
              alt="Vancouver House Wash"
              className="h-16 w-auto mb-4"
            />
            <p className="!text-sm mb-4">Professional exterior cleaning services for residential and commercial properties across Metro Vancouver.</p>
            <p className="!font-semibold text-green-400">Vancouver House Wash</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('services')} className="hover:text-green-400 transition-colors">Services</button></li>
              <li><button onClick={() => scrollToSection('gallery')} className="hover:text-green-400 transition-colors">Gallery</button></li>
              <li><button onClick={() => scrollToSection('testimonials')} className="hover:text-green-400 transition-colors">Testimonials</button></li>
              <li><button onClick={() => scrollToSection('booking')} className="hover:text-green-400 transition-colors">Book Online</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="hover:text-green-400 transition-colors">Contact Us</button></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Service Areas</h3>
            <ul className="space-y-1 text-sm">
              {serviceAreas.slice(0, 6).map((area, index) => (
                <li key={index} className="flex items-center">
                  <span className="w-1.5 h-1.5 bg-green-400 rounded-full mr-2"></span>
                  {area}
                </li>
              ))}
              <li className="text-green-400 font-medium mt-2">+ More areas</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:236-268-0552" className="flex items-center hover:text-green-400 transition-colors">
                  <Phone className="h-4 w-4 mr-2" />
                  (236) 268-0552
                </a>
              </li>
              <li>
                <a href="mailto:vanhousewash@gmail.com" className="flex items-center hover:text-green-400 transition-colors">
                  <Mail className="h-4 w-4 mr-2" />
                  vanhousewash@gmail.com
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-green-700 transition-colors"><Facebook className="h-5 w-5" /></a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-green-700 transition-colors"><Instagram className="h-5 w-5" /></a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-green-700 transition-colors"><Twitter className="h-5 w-5" /></a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Vancouver House Wash. All rights reserved.</p>
          <p className="mt-2 text-gray-500">
            Licensed & Insured | Professional Exterior Cleaning Services
          </p>
          <button
            onClick={() => navigate('/admin/login')}
            className="mt-2 text-gray-600 hover:text-gray-400 text-xs transition-colors"
            data-testid="footer-admin-link"
          >
            Admin Login
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
